import React from 'react';

const JobResultCard = ({ job, index }) => {
  const formatSalary = (salary) => {
    if (!salary) return 'Compensation TBD';
    if (salary.min && salary.max) {
      return `$${salary.min.toLocaleString()} – $${salary.max.toLocaleString()}`;
    }
    if (salary.max) {
      return `Up to $${salary.max.toLocaleString()}`;
    }
    if (salary.min) {
      return `From $${salary.min.toLocaleString()}`;
    }
    return 'Compensation TBD';
  };

  const getReferralBadge = (likelihood) => {
    if (!likelihood) return null;
    if (likelihood >= 0.7) {
      return (
        <span className="inline-flex items-center rounded-full bg-[#34C759]/12 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-[#248A3D]">
          Strong fit
        </span>
      );
    }
    if (likelihood >= 0.5) {
      return (
        <span className="inline-flex items-center rounded-full bg-[#FF9500]/12 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-[#C93400]">
          Good fit
        </span>
      );
    }
    return null;
  };

  return (
    <article className="group rounded-[16px] bg-white p-4 shadow-ios-sm border border-black/[0.06] transition-all duration-200 hover:shadow-ios-md hover:border-black/[0.08] active:scale-[0.995] font-ios">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-[#8E8E93] mb-1">
            Role {index + 1}
          </p>
          <h3 className="text-[17px] font-semibold leading-snug text-[#1C1C1E] tracking-[-0.01em] group-hover:text-[#007AFF] transition-colors">
            {job.title || 'Untitled position'}
          </h3>
          <p className="mt-1 text-[15px] text-[#636366]">{job.company || 'Company'}</p>
        </div>
        {getReferralBadge(job.referralLikelihood)}
      </div>

      <div className="flex flex-wrap gap-x-4 gap-y-2 text-[13px] text-[#8E8E93] mb-3">
        {job.location && (
          <span className="inline-flex items-center gap-1">
            <span className="opacity-70" aria-hidden>
              ◎
            </span>
            {job.location}
          </span>
        )}
        {job.remote && (
          <span className="inline-flex items-center gap-1 text-[#007AFF] font-medium">
            Remote
          </span>
        )}
        <span className="inline-flex items-center gap-1">
          <span className="opacity-70" aria-hidden>
            ◆
          </span>
          {formatSalary(job.salary)}
        </span>
      </div>

      {job.requiredSkills && job.requiredSkills.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-3">
          {job.requiredSkills.slice(0, 5).map((skill, idx) => (
            <span
              key={idx}
              className="rounded-lg bg-[#F2F2F7] px-2.5 py-1 text-[12px] font-medium text-[#3A3A3C]"
            >
              {skill}
            </span>
          ))}
          {job.requiredSkills.length > 5 && (
            <span className="rounded-lg bg-[#F2F2F7] px-2.5 py-1 text-[12px] text-[#8E8E93]">
              +{job.requiredSkills.length - 5}
            </span>
          )}
        </div>
      )}

      {job.companyMoraleScore && (
        <div className="mb-3 text-[13px] text-[#636366]">
          Culture <span className="font-semibold text-[#1C1C1E]">{job.companyMoraleScore.toFixed(1)}</span>
          <span className="text-[#8E8E93]">/5</span>
        </div>
      )}

      <div className="flex items-center justify-between border-t border-black/[0.06] pt-3 mt-1">
        <span className="text-[12px] text-[#8E8E93]">Open in Jobs</span>
        <svg
          className="h-4 w-4 text-[#C7C7CC] group-hover:text-[#007AFF] transition-colors"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </article>
  );
};

export default JobResultCard;
